import { LocalizationData } from '../../../../core/src/models/common/localization/localization-data'
import { BaseStoreFactory } from './factories/base-store.factory'

export const getLocalizationStore = BaseStoreFactory.Create<LocalizationData>('localization')
